import { GlassFooter } from "./liquid/LiquidPrimitives";

interface FooterProps {
  companyName: string;
  year?: number;
}

export default function Footer(_: FooterProps) {
  return <GlassFooter companyName={_.companyName} year={_.year} />;
}
